import React, {  } from 'react';
import { Box, Grid, Stack } from '@mui/material';
import StandardView from '../components/core/StandardView';
import SearchForm from '../components/search/SearchForm';
import KatyBio from '../components/core/KatyBio';

// Material UI

// Import our store

// API

// Types
interface Props {

}

const LandingPage = ({}: Props) => {
  const renderLogos = () => {
    return <Grid item xs={12}>
      <Grid container>
        <Grid item xs={4}>
          <Box justifyContent={'center'} alignContent={'center'}>
            <a href='https://www.umassmed.edu/rti/'>
              <img src="RTI_logo_outlines.svg" alt="logo" width={'100%'} style={{objectFit:'contain', maxHeight:'128px', marginLeft:'auto', marginRight:'auto', display:'block', width:'100%'}} />
            </a>
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Box justifyContent={'center'} alignContent={'center'}>
            <a href='https://www.wpi.edu/people/faculty/dkorkin'>
              <img src="korkin_lab.png" alt="logo" width={'100%'} style={{objectFit:'contain', maxHeight:'128px', marginLeft:'auto', marginRight:'auto', display:'block', width:'100%'}} />
            </a>
          </Box>
        </Grid>
        <Grid item xs={4}>
          <Box justifyContent={'center'} alignContent={'center'}>
            <a href='https://www.umassmed.edu/khvorovalab/'>
              <img src="khvorova_logo.svg" alt="logo" width={'100%'} style={{objectFit:'contain', maxHeight:'128px', marginLeft:'auto', marginRight:'auto', display:'block', width:'100%'}} />
            </a>
          </Box>
        </Grid>
      </Grid>
    </Grid>;
  }

  return (
    <StandardView>
      <Stack direction={'column'} gap={8}>
        {/* Search form */}
        <SearchForm/>

        {/* Logos */}
        {renderLogos()}

        {/* Content From Katy about the Portal/Project and Katy */}
        <KatyBio/>
      </Stack>
    </StandardView>
  );
};

export default LandingPage;